/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterDto } from '../../models/center-dto';

export interface AdminCenterControllerRestoreCenter$Params {
  id: string;
}

export function adminCenterControllerRestoreCenter(http: HttpClient, rootUrl: string, params: AdminCenterControllerRestoreCenter$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterDto>> {
  const rb = new RequestBuilder(rootUrl, adminCenterControllerRestoreCenter.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterDto>;
    })
  );
}

adminCenterControllerRestoreCenter.PATH = '/api/center/admin/{id}/restore';
